<div class="header">
  <button mat-icon-button class="outlined fit-icon" color="primary" (click)="previousClicked()" [disabled]="!previousEnabled">
    <mat-icon svgIcon="chevron-left"></mat-icon>
  </button>
  <span>{{ periodLabel }}</span>
  <button mat-icon-button class="outlined fit-icon" color="primary" (click)="nextClicked()" [disabled]="!nextEnabled">
    <mat-icon svgIcon="chevron-right"></mat-icon>
  </button>
</div>
